import { inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { User } from '../models/app.model';
import { Login, Logout, ResetAppState, SetActiveTab } from '../store/actions/app.actions';
import { AppState } from '../store/app.state';

@Injectable({
  providedIn: 'root'
})
export class AppStateService {
  private readonly store = inject(Store);

  // Selectors

  getUser$(): Observable<User> {
    return this.store.select(AppState.getUser);
  }

  getUser(): User {
    return this.store.selectSnapshot(AppState.getUser);
  }

  getActiveTab$(): Observable<string> {
    return this.store.select(AppState.getActiveTab);
  }

  getActiveTab(): string {
    return this.store.selectSnapshot(AppState.getActiveTab);
  }

  isMailOrderCostsSelected$(): Observable<boolean> {
    return this.store.select(AppState.isMailOrderCostsSelected);
  }

  isMailOrderCostsSelected(): boolean {
    return this.store.selectSnapshot(AppState.isMailOrderCostsSelected);
  }

  // Actions

  login$(username: string): Observable<void> {
    return this.store.dispatch(new Login(username));
  }

  logout$(): Observable<void> {
    return this.store.dispatch(new Logout());
  }

  setActiveTab$(tab: string): Observable<void> {
    return this.store.dispatch(new SetActiveTab(tab));
  }

  resetAppState$(): Observable<void> {
    return this.store.dispatch(new ResetAppState());
  }
}
